import { render, staticRenderFns } from "./biletiade.vue?vue&type=template&id=50fbb70a&"
import script from "./biletiade.vue?vue&type=script&lang=js&"
export * from "./biletiade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports